<template>
	<div class="innerBox">
		<h2 class="mb-4">Input Kas Kecil</h2>

		<div class="row rounded border border-secondary p-10" style="color:white;background-color:black;min-height:500px">
			<div class="col-4">
				<h5>Preview Gambar Faktur Pembayaran :</h5>

				<img :src="url" v-if="url" style="width:100%;height:auto;max-width:100%;"/>
			</div>
			<div class="col-8">
				<div class="row mt-4 text-center">
					<div class="col-4 middleDiv">
						<h5>Pilih Pekerja</h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-6">
						<Multiselect
							:options="labourerList.map(x => x.id)"
							:custom-label="opt => labourerList.find(x => x.id == opt).name"
							v-model="form.labourer_id"
							v-if="labourerList"
							class="w-100"
						/>
					</div>
				</div>

				<div class="row mt-3 text-center">
					<div class="col-4 middleDiv">
						<h5>Total Harga</h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-6">
						<input type="text" v-model="form.amount" class="form-control"/>
					</div>
				</div>

				<div class="row mt-3 text-center">
					<div class="col-4 middleDiv">
						<h5>Deskripsi Kas Kecil</h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-6">
						<textarea 
							rows="5"
							class="w-100 form-control"
							v-model="form.description"
						/>
					</div>
				</div>

				<div class="row mt-3 text-center">
					<div class="col-4 middleDiv">
						<h5>Unggah Gambar Faktur Pembayaran</h5>
						( Maximum 4 MB per File )
						
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-6">
						<span v-if="fileError != ''" class="mb-2" style="color:red;font-weight:bold">{{fileError}}</span>
						<input type="file" name="myImage" accept="image/*"  class="form-control" @change="validateSize"/>
					</div>
				</div>
				<div class="row mt-4">
					
					<div class="offset-6 col-3">
						
						<!-- <button class="btn btn-danger w-100">Batal</button> -->
					</div>
					<div class="col-3" >
						<button class="btn btn-primary w-100" @click="submit">Selesai</button>
					</div>
				</div>
			</div>
		</div>

		

		
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import env from '@/env'
export default {
	components : {
		Multiselect
	},
	data () {
		return {
			form : {
				labourer_id : null,
				description : '',
				amount : null,
				attachment : null,
				debit_credit : 1
			},
			file : null,
			url : null,
			fileError : '',
			labourerList : null
		}
	},
	watch : {
		'form.amount' : function () {
			const result = this.form.amount.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.amount = result);
		}
	},
	mounted () {
		this.getListOfLabourer()
	},
	methods : {
		validateSize(data) {
			var file = data.target.files[0];

			var size  = file.size / 1024 / 1024;

			if(size > 20)
			{
				this.fileError = "Limit Size Gambar 8 MB";
				return false;
			}

			this.fileError = "";
			this.file = file ;
			this.url = URL.createObjectURL(file);

			return true;
		},
		async uploadImage () {
			let formData = new FormData()
			let image = null

			formData.append('work_order', this.file)

			
			let response = await this.$http.post(env.urlStart + '/api/v1/workorder/image', formData, {headers : {"Content-Type":'multipart/form-data'}})
			
			image = response.data.data.filename

			return image
		},
		getListOfLabourer () {
			this.labourerList = null

			this.$http.get('/api/v1/masterData/labourer?pagination=false')
			.then((resp) => {
				this.labourerList = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
		async submit() {
		

			let error = await this.validate()

			if(error.length > 0) {
				this.$store.dispatch('triggerAlert', [false, error]);
			}
			else {
				let form = Object.assign({} , this.form)
				form.amount = parseFloat(form.amount.split(',').join(''))
				this.fileError = ''
				this.$http.post('/api/v1/treasury/petty-cash' , form)
				.then((resp) => {
					this.$store.dispatch('triggerAlert', [true, `Kas Kecil Berhasil di Masukkan.`]);

					this.form = {
						labourer_id : null,
						description : '',
						amount : null,
						attachment : null,
						debit_credit : -1
					}
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		async validate () {
			let keys = Object.keys(this.form)
			let errors = []

			for(var i = 0 ; i < keys.length ; i++) {
				if(keys[i] == 'description')
					continue

				else if(keys[i] == 'attachment') {
					if(!this.file) {
						errors.push('Harap Pilih Gambar Faktur Pembayaran Terlebih Dahulu.')
					}
					else {
						let image = await this.uploadImage()
						this.form.attachment = image
					}
				}

				else if(this.form[keys[i]] == '' || this.form[keys[i]] == null) {
					errors.push(`${this.translate(keys[i])} Wajib Dipilih Atau Diisi`)
				}
			}
			
			return errors
		},
		translate (word) {
			let dictionary = [{
				variable : 'labourer_id',
				translated : 'Pekerja'
			}, {
				variable : 'description',
				translated : 'Deskripsi Kas Kecil'
			},{
				variable : 'amount',
				translated : 'Total Harga'
			},{
				variable : 'attachment',
				translated : 'Gambar Faktur Pembayaran'
			}]

			let jsonResp = dictionary.find(x => x.variable == word).translated
			return jsonResp
		}
	}
}
</script>

<style>
	.middleDiv {
		margin-top: auto;
		margin-bottom: auto;
	}
</style>